import React, { Component } from "react";
import { Row, Col } from "antd";
import Category from "../../components/CategoriesCard";
import ShippingCost from "../../components/ShpingCost";
import CatalogCard from "../../components/catalogCard";
import { Store } from "../../store";
import { connect } from "react-redux";
import { CatalogAction,UserAction } from "../../store/actions";

class Catalog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClose: false,
      isOpenModal: false,
      filters: {
        order: "asc",
        page: 1,
        per_page: 12,
        column: "name",
        category_id: 1,
        totalCount: 0,
        currentCount: 0,
        total_pages: 0,
      },
      categoryName: "Standard Products",

      shipingprice: {
        am_charges: "0.0",
        pm_charges: "0.0",
      },
      price: "",

      // rmx_product_additives: {
      //   price: "",
      // },
    };
  }

  componentDidMount() {
    const { getProducts, getCategories, getShippingCost,getUserDetails } = this.props;
    const userId=this.props.user?.[2].rmx_company_user?.id

    getProducts(this.state.filters, false);
    getCategories();
    getShippingCost();
    getUserDetails(userId)
  }

  componentDidUpdate(preProps, preState) {
    const { getProducts } = this.props;

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filters: {
          ...this.state.filters,
          page: this.props?.metaData?.current_page,
          totalCount: this.props?.metaData?.total_records,
          currentCount: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }

    if (
      preState.filters.category_id !== this.state.filters.category_id ||
      preState.filters.column !== this.state.filters.column ||
      preState.filters.per_page !== this.state.filters.per_page ||
      preState.filters.page !== this.state.filters.page
    ) {
      getProducts(this.state.filters, false);
    }
    if (preProps.shipingprice !== this.props.shipingprice) {
      this.setState({
        shipingprice: {
          am_charges: this.props?.shipingprice?.am_charges,
          pm_charges: this.props?.shipingprice?.pm_charges,
        },
      });
    }
  }

  currentPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page + 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page - 1,
      },
    });
  };
  abc = (key) => {
    this.setState({
      filters: {
        ...this.state.filters,
        category_id: key.id,
      },
      categoryName: key.name,
    });
  };
  onChangeShowingFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        per_page: value,
      },
    });
  };

  onUpdateShippingCost = (e, type) => {
    this.setState({
      shipingprice: {
        ...this.state.shipingprice,
        [type]: e,
      },
    });
  };

  onUpdatePrice = (updatedPrice) => {
    this.setState({
      price: updatedPrice,
    });
  };

  onChangeFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        column: value,
      },
    });
  };
  callOnCallBack = () => {
    this.props.getProducts(this.state.filters, false);
  };
  render() {
    return (
      <Row justify="space-around">
        <Col xl={6} lg={6} xs={24} sm={24} md={24}>
          <Category
            abc={this.abc}
            categorey={this.props.categories}
            {...this.props}
          />
          <ShippingCost
            onUpdateShippingCost={this.onUpdateShippingCost}
            updateShippingCost={this.props.updateShippingCost}
            value={this.state.shipingprice}
            shipingprice={this.props.shipingprice}
          />
        </Col>
        <Col xl={17} lg={17} xs={24} sm={24} md={24}>
          <CatalogCard
            {...this.props}
            categoryName={this.state.categoryName}
            onChangeFilter={this.onChangeFilter}
            onChangeShowingFilter={this.onChangeShowingFilter}
            metaData={this.state.filters}
            currentPage={this.currentPage}
            previousPage={this.previousPage}
            updateProductPrice={this.props.updateProduct}
            onUpdateProductPrice={this.onUpdatePrice}
            value={this.state.price}
            onOpenModal={(e) => this.setState({ price: e })}
            callOnCallBack={this.callOnCallBack}
            dividerShow={true}
          />
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    products: store.CatalogReducer.products,
    metaData: store.CatalogReducer.metaData,
    categories: store.CatalogReducer.categories,
    shipingprice: store.CatalogReducer.shipingprice,
    isLoadingCategory: store.CatalogReducer.isLoadingCategorey,
    isLoading: store.CatalogReducer.isLodading,
    user: store.AuthReducer.user,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCategories: (params) => dispatch(CatalogAction.getCategoriesReq(params)),
    getProducts: (params, isTrue) =>
      dispatch(CatalogAction.getProductReq(params, isTrue)),
    updateShippingCost: (value, id) =>
      dispatch(CatalogAction.updateShipingCostReq(value, id)),
    getShippingCost: () => dispatch(CatalogAction.getShipingCostReq()),
    updateProduct: (value, id, active, cb) =>
      dispatch(CatalogAction.updateProductReq(value, id, active, cb)),
      getUserDetails:(id)=>dispatch(UserAction.getUserDetailReq(id))

      
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Catalog);
